import { css, keyframes, styled } from '@mui/material';

const bowBounce = keyframes`
    0% {
      transform: scaleY(0.8);
    }
    25% {
      transform: scaleY(1);
    }
    50% {
      transform: scaleY(0.7);
    }
    75% {
      transform: scaleY(1);
    }
    100% {
      transform: scaleY(0.8);
    }
`;

const containerBounce = keyframes`
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-4%);
    }
    100% {
      transform: translateY(0);
    }
`;

const containerOpen = keyframes`
  from {
    transform: none;
  }
  to {
    transform: rotate(-25deg) translate(-3rem, -1rem);
  }
`;

const balloonFloat = keyframes`
  0% {
    opacity: 0;
    transform: translate(160px, -7vh);
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translate(190px, -200vh) scale(1.5);
  }
`;

interface AnimationProps {
  shouldAnimate: boolean;
}

export const Wrapper = styled('svg')`
  overflow: visible;
`;

export const Bow = styled('g')`
  animation: ${bowBounce} 2s linear infinite 400ms;
  transform-origin: 0% 30%;
`;

export const LidContainer = styled('g')<AnimationProps>`
  animation: ${containerBounce} 2s cubic-bezier(0, 1.01, 0.18, 0.99) infinite 400ms;

  ${({ shouldAnimate }) =>
    shouldAnimate &&
    css`
      animation: ${containerOpen} cubic-bezier(0, 1.01, 0.18, 0.99) forwards 400ms;
    `};
`;

export const GiftBox = styled('g')``;

export const Balloon = styled('g')<AnimationProps>`
  opacity: 0;

  ${({ shouldAnimate }) =>
    shouldAnimate &&
    css`
      animation: ${balloonFloat} ease-in-out forwards 4s;
    `};
`;
